export const RI003A = {
    Jwt: {
        // provisioning
        previewOrder: 'api/reference-implementation/web-application/1.0/internal/order/ri003a/preview',
        submitOrder: 'api/reference-implementation/web-application/1.0/internal/order/ri003a/submit',
        reSubmit: 'api/reference-implementation/web-application/1.0/internal/order/ri003a/resubmit',
        submitApproval: 'api/reference-implementation/web-application/1.0/internal/order/submit-approval',
        costCalculation: 'ri-cost-calculation.json', // 'api/reference-implementation/web-application/1.0/internal/cost-calculation',
        internalPreviewOrder: 'api/reference-implementation/web-application/1.0/internal/preview/order',
        downloadTF: 'api/reference-implementation/web-application/1.0/internal/order',
    },
};
export default RI003A;
